export class MaxPowerItem {
  constructor(maxPower: number, maxPowerText: string) {
    this.MaxPower = maxPower;
    this.MaxPowerKw = maxPower / 1000;
    this.MaxPowerText = maxPowerText;
  }

  MaxPower: number;
  MaxPowerKw: number;
  MaxPowerText: string;
}
